export default "__VITE_ASSET__54b60ee1__"